import { render, staticRenderFns } from "./addTouchpoint.vue?vue&type=template&id=6dd10c66"
import script from "./addTouchpoint.vue?vue&type=script&lang=js"
export * from "./addTouchpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports